

import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { imgStoragePath } from '../../constants';
import { getGlobalCookie, setGlobalCookie, setGlobalTimeCookie } from '../../utils';
import { Col, Row } from 'reactstrap';
export default function DeploymentMessage({ row, margin }) {
    const [deploymentFlag, setDeploymentFlag] = useState(false)
    const [bannerData, setBannerData] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const getInfo = () => {
        setLoading(true)
        fetch(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/maintenance_banner/info.json?timestamp=${new Date().getTime()}`)
        .then(res => res.json())
        .then(resp => {
                setLoading(false)
                const dismissed = JSON.parse(getGlobalCookie('showBanner') || '{}')
                if (resp?.for_lease && (resp?.id !== dismissed?.lease || !dismissed?.lease)) {
                    setDeploymentFlag(resp?.for_lease)
                    setBannerData(resp)
                } else {
                    return
                }
            })
            .catch(() => { })
    }

    useEffect(() => {
        getInfo()
        //URL will be called in every 6 hours 
        const interval = setInterval(getInfo, (6 * 60 * 60 * 1000))
        return () => clearInterval(interval)
    }, [])

    const getClientData = () => {
        let oldCookie = JSON.parse(getGlobalCookie('showBanner'))
        let leaseCookie = { lease: bannerData?.id }
        setGlobalCookie('showBanner', JSON.stringify({ ...oldCookie, ...leaseCookie }), 3)
    }
    let marginVal = margin
    return (
        <>
            { deploymentFlag && !isLoading ?
                    row ?
                        <Row style={marginVal ? { marginTop: marginVal } : null}>
                            <Col md="12">
                                <p className="deployment-info">
                                    <span>{bannerData?.message ||'Under Scheduled maintenance'}</span>
                                    <span >
                                        <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                                    </span>
                                </p>
                            </Col>
                        </Row>
                        :
                        <Grid item sm="12">
                            <p className="deployment-info">
                                <span>{bannerData?.message || 'Under Scheduled maintenance'}</span>
                                <span >
                                    <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                                </span>
                            </p>
                        </Grid>
                    :
                    null}
        </>
    )
}
